export default {
  data() {
    return {};
  },
  computed: {
    maintaiGame() {
      return this.$store.getters.getPacketConfig?.maintain || {};
    },
    hidegd() {
      const getHideBrandId = this.$store.getters.getHideBrandId;
      const getHideGameId = this.$store.getters.getHideGameId;
      const getHideTmpGameIds = this.$store.getters.getHideTmpGameIds;
      return (opt) => {
        // console.log(opt, "---------qweqqw--------");
        const brand = opt.brand_id === getHideBrandId;
        const game = getHideGameId.includes(opt.gameGroupSid);
        const tmpGame = getHideTmpGameIds.includes(opt.id);
        // console.log(brand, game, tmpGame, "---------qweqqw----------------");
        return !(brand || game || tmpGame);
      };
    },
  },
};
